import { render } from "./SVGCopy.vue?vue&type=template&id=5582d5a0"
import script from "./SVGCopy.vue?vue&type=script&lang=js"
export * from "./SVGCopy.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__